import * as React from 'react';

import { Container } from '../Common/Common.styles';
import NavBar from '../../../components/CustomNav/CustomNav.Component';
import CalendlyBooking from '../../../components/CalendlyBooking/CalendlyBooking.Component';


class Booking extends React.Component {
    public componentDidMount() {
        // load the calendly script into the dom head
        // unnecessary if using an iframe
    }

    public render() {
        return (
         <Container>
             <NavBar/>
             <CalendlyBooking url="https://calendly.com/kibetdennis/testing-plex-calendly-integration?background_color=1a1a1a&text_color=f1f1f1&primary_color=3ee9f7"
/>
         </Container>
        );
    }
}

export default Booking;


// WEBPACK FOOTER //
// ./src/pages/Onboard/Calendly/Booking.Component.tsx